import { loadStripe } from '@stripe/stripe-js';
import { stripeLocale } from '../i18n';
import { CheckoutFlowError, presentLocalizedError } from './errorPresentation';

// Authenticate the bound intent only; settlement remains owned by Core.
export async function authenticatePayment(payment: {
  clientSecret?: string;
  publishableKey?: string;
}): Promise<void> {
  const { clientSecret, publishableKey } = payment;
  const failure = () => new CheckoutFlowError(presentLocalizedError({
    key: 'error.authentication', kind: 'payment', action: 'retry',
  }));
  if (!clientSecret || !publishableKey) throw failure();
  try {
    const stripe = await loadStripe(publishableKey, { locale: stripeLocale() });
    if (!stripe) throw failure();
    const result = await stripe.handleNextAction({ clientSecret });
    if (result.error) throw failure();
  } catch {
    throw failure();
  }
}
